import { Sidebar } from './sidebar';
import { TopBar } from './top-bar';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '@/features/platform/contexts/auth-context';

export const ManagementLayout = () => {
    const { user, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-slate-50 dark:bg-slate-950">
                <div className="w-8 h-8 rounded-full border-2 border-slate-200 dark:border-neutral-800 border-t-blue-500 animate-spin" />
            </div>
        );
    }

    if (!user) {
        const returnUrl = location.pathname + location.search + location.hash;
        try {
            sessionStorage.setItem('auth_return_url', returnUrl);
        } catch (e) {}
        return <Navigate to={`/auth/login?returnUrl=${encodeURIComponent(returnUrl)}`} replace />;
    }

    return (
        <div className="flex h-screen overflow-hidden bg-slate-50 dark:bg-slate-950">
            <Sidebar />

            <main className="flex-1 flex flex-col h-full overflow-hidden">
                <TopBar />

                <div className="flex-1 overflow-y-auto no-scrollbar">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};
